import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/sass/styles.scss";
import "./assets/sass/contarst.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import './i18n';
import { Suspense } from "react";
import "./Constants"
import {ErrorBoundary} from 'react-error-boundary';
import AppErrorPage from './pages/AppErrorPage';
let persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <Suspense >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary FallbackComponent={AppErrorPage}>
            <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
   </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
